export default __webpack_public_path__ + "static/lframe-calculator-f10c76fccb1a43bb362b7f3e427483da.png";